import { ArrowBack } from "@mui/icons-material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TradeDetailsCard from "../../components/Accountmetrics/TradeDetailsCard";
import CandleStickChart from "../../components/TraderChart/Traderchart";
import "./style.scss";

const TradeDetailsPage = () => {
  const { state } = useLocation();
  const {
    positionInfo,
    period,
    selectedTradeDate,
    candleStickSymbol,
    candleStickTime,
    positions,
  } = JSON.parse(sessionStorage.getItem("tradeDetailsState")) || {};


  const [active, setActive] = useState("1d");
  const [period1, setPeriod1] = useState(period);
  const navigate = useNavigate();
  const [renderInfo, setRenderInfo] = useState(false);
  const [candleStickTime1, setCandleStickTime1] = useState(candleStickTime);
  const [activeTimeFrame, setActiveTimeFrame] = useState("one_minute");
  const [info, setInfo] = useState(positionInfo);


  const splitTrades = (trades) => {
    if (!Array.isArray(trades) || trades.length === 0) return { earliest: null, latest: null };

    return trades.reduce(
      (result, trade) => {
        const tradeDate = new Date(trade.date || trade.tradeDateTime);

        if (!result.earliest || tradeDate < new Date(result.earliest.date || result.earliest.tradeDateTime)) {
          result.earliest = trade;
        }

        if (!result.latest || tradeDate > new Date(result.latest.date || result.latest.tradeDateTime)) {
          result.latest = trade;
        }

        return result;
      },
      { earliest: null, latest: null }
    );
  };

  // inside your component
  const { earliest, latest } = splitTrades(info?.info || []);

  return (
    <div className="view-trade-container">
      <div className="chart-nav-bar">
        <button
          className="chart-back-arrow"
          onClick={() =>
            navigate("/AccountMetric", { state: { fromTradeDetails: true } })
          }
        >
          <ArrowBack color="black" />
        </button>
      </div>
      <CandleStickChart
        period={period1}
        selectedDate={selectedTradeDate}
        symbol={candleStickSymbol}
        candleStickTime={candleStickTime1}
        positions={positions}
        setPositionInfo={setInfo}
        color={info?.info?.[1]?.profit > 0 ? "green" : "red"}
        activeTimeFrame={activeTimeFrame}
        setRenderInfo={setRenderInfo}
        trade={info?.info?.length === 1 ? info?.info?.[0] : info?.info?.[1]}
        information={info?.info}
      />
      {renderInfo && (

        <TradeDetailsCard
          trade={earliest}
          allTrades={info}
          profit={latest?.profit}
        />
      )}
    </div>
  );
};

export default TradeDetailsPage;
